import { CreateAnnouncementDto, IAnnouncement } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class AnnouncementApi {
  static getAnnouncements(): Promise<AxiosResponse<IAnnouncement[]>> {
    return AdmiralApi.apiCall<IAnnouncement[]>({
      method: 'POST',
      url: `${BASE_URL}/announcement`,
    });
  }

  static getAnnouncement(id: string): Promise<AxiosResponse<IAnnouncement>> {
    return AdmiralApi.apiCall<IAnnouncement>({
      method: 'POST',
      url: `${BASE_URL}/announcement/${id}`,
    });
  }

  static create(createAnnouncementDto: CreateAnnouncementDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'PUT',
      url: `${BASE_URL}/announcement`,
      data: createAnnouncementDto,
    });
  }

  static delete(id: string): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'DELETE',
      url: `${BASE_URL}/announcement/${id}`,
    });
  }
}
